import { createSlice } from "@reduxjs/toolkit";
import { fetchTabMappings } from "../Thunks/tabMappingThunk";
import { addAsyncResourceThunk } from "../helpers/asyncResource";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const tabMappingSlice = createSlice({
  name: "tabMapping",
  initialState,
  reducers: {
    clearTabMappings: (state) => {
      state.data = null;
      state.error = null;
    },
    addTabMapping: (state, action) => {
      const newItem = action.payload;
      if (!state.data) {
        state.data = { list: [newItem], totalCount: 1 };
        return;
      }
      if (!Array.isArray(state.data.list)) {
        state.data.list = [];
      }
      state.data.list.push(newItem);
      if (typeof state.data.totalCount === "number") {
        state.data.totalCount += 1;
      }
    },
    deleteTabMapping: (state, action) => {
      const id = action.payload;
      if (!state.data?.list) return;
      state.data.list = state.data.list.filter((item) => item.id !== id);
      if (typeof state.data.totalCount === "number") {
        state.data.totalCount = Math.max(0, state.data.totalCount - 1);
      }
    },
    updateTabMapping: (state, action) => {
      const { id, tag, account } = action.payload;
      if (!state.data?.list) return;
      const index = state.data.list.findIndex((item) => item.id === id);
      if (index === -1) return;
      state.data.list[index] = { ...state.data.list[index], tag, account };
    },
  },
  extraReducers: (builder) => {
    addAsyncResourceThunk(builder, fetchTabMappings);
  },
});

export const { clearTabMappings, addTabMapping, deleteTabMapping, updateTabMapping } =
  tabMappingSlice.actions;

export const selectTabMappingData = (state) => state.tabMapping.data;
export const selectTabMappingLoading = (state) => state.tabMapping.loading;
export const selectTabMappingError = (state) => state.tabMapping.error;

export default tabMappingSlice.reducer;
